import { lazy, Suspense, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import ScrollToTop from "./components/ScrollToTop";
import ReadingProgress from "./components/ReadingProgress";
import { QuoteFormProvider } from "./components/QuoteFormContext";
import PremiumLoader from "./components/PremiumLoader";

/*
 * The home route is bundled eagerly because it is the entry point for nearly
 * every visit; every other route is split out so a first paint only downloads
 * the code that route actually needs. The chat bubble and the visit popup are
 * split too — neither is part of the first screen.
 */
const Services = lazy(() => import("./pages/Services"));
const ServiceDetail = lazy(() => import("./pages/ServiceDetail"));
const Gallery = lazy(() => import("./pages/Gallery"));
const Blog = lazy(() => import("./pages/Blog"));
const BlogPost = lazy(() => import("./pages/BlogPost"));
const About = lazy(() => import("./pages/About"));
const Locations = lazy(() => import("./pages/Locations"));
const LocationDetail = lazy(() => import("./pages/LocationDetail"));
const NotFound = lazy(() => import("./pages/NotFound"));
const VisitPopup = lazy(() => import("./components/VisitPopup"));
const ChatWidget = lazy(() => import("./components/ChatWidget"));

const App = () => {
  const [loaderDone, setLoaderDone] = useState(false);

  return (
    <QuoteFormProvider>
      <PremiumLoader onDone={() => setLoaderDone(true)} />
      <ReadingProgress />
      <Suspense fallback={null}>
        <VisitPopup ready={loaderDone} />
        <ChatWidget />
      </Suspense>
      <BrowserRouter>
        <ScrollToTop />
        <Suspense fallback={null}>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/:slug" element={<ServiceDetail />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/about" element={<About />} />
            <Route path="/locations" element={<Locations />} />
            <Route path="/locations/:slug" element={<LocationDetail />} />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </QuoteFormProvider>
  );
};

export default App;
